import { CardButton } from '@cart/ui'
import tw, { styled } from 'twin.macro'

export const OrgCard = styled(CardButton)(() => [
  tw`border-monochrome-500 hover:border-primary-700`,
  tw`[& button]:(p-0 text-black/[0.87] hover:bg-primary-50)`,
  tw`[& .MuiCardContent-root]:p-0`,
])
